import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DownloadSimple, ArrowsClockwise, MagnifyingGlass } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { API_BASE, formatApiErrorDetail } from "@/lib/api";

export default function Transcripts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/students");
      setItems(data.items || []);
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Yüklenemedi.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filtered = items.filter((s) => {
    const txt = q.trim().toLowerCase();
    if (!txt) return true;
    return (
      String(s.student_id || "").toLowerCase().includes(txt) ||
      String(s.holder_name || "").toLowerCase().includes(txt) ||
      String(s.nationality || "").toLowerCase().includes(txt)
    );
  });

  return (
    <div className="p-6 lg:p-10" data-testid="transcripts-page">
      <span className="label-eyebrow">/ Öğrenci Transkriptleri</span>
      <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tighter text-slate-900 mt-3">
        Karne arşivi
      </h1>
      <p className="text-slate-600 mt-2 max-w-2xl">
        Aynı <b>öğrenci numarasına</b> bağlanmış tüm sertifikaların özet karnesini PDF olarak indirin.
        Bir sertifikaya öğrenci numarası atamak için <Link to="/admin" className="text-[#0B2046] underline">Sertifika Kaydı</Link> sayfasındaki her satırın "ID Ata" butonunu kullanın.
      </p>

      <div className="mt-8 flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[260px] max-w-xl">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            data-testid="transcripts-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Öğrenci no, isim veya uyrukla ara…"
            className="w-full pl-10 pr-4 py-2.5 border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#0B2046]"
          />
        </div>
        <button
          onClick={load}
          className="px-3 py-2 border border-slate-300 text-slate-700 hover:bg-slate-50 inline-flex items-center gap-2 text-sm"
        >
          <ArrowsClockwise size={14} /> Yenile
        </button>
      </div>

      <div className="mt-6 border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500">
            <tr>
              <th className="px-4 py-3 text-left label-eyebrow">Öğrenci №</th>
              <th className="px-4 py-3 text-left label-eyebrow">Ad Soyad</th>
              <th className="px-4 py-3 text-left label-eyebrow">Uyruk</th>
              <th className="px-4 py-3 text-left label-eyebrow">Doğum</th>
              <th className="px-4 py-3 text-right label-eyebrow">Sertifika Sayısı</th>
              <th className="px-4 py-3 text-right label-eyebrow">Toplam Saat</th>
              <th className="px-4 py-3 text-right label-eyebrow">Transkript</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={7} className="px-4 py-8 text-center label-eyebrow">Yükleniyor…</td></tr>
            )}
            {!loading && filtered.length === 0 && (
              <tr>
                <td colSpan={7} className="px-4 py-12 text-center label-eyebrow">
                  Henüz öğrenci numarası atanmış sertifika yok
                </td>
              </tr>
            )}
            {filtered.map((s) => (
              <tr key={s.student_id} className="border-t border-slate-200 hover:bg-slate-50">
                <td className="px-4 py-3 font-mono-plex font-bold">{s.student_id}</td>
                <td className="px-4 py-3">{s.holder_name}</td>
                <td className="px-4 py-3">{s.nationality}</td>
                <td className="px-4 py-3 font-mono-plex">{s.date_of_birth}</td>
                <td className="px-4 py-3 text-right font-mono-plex">{s.certificates_count}</td>
                <td className="px-4 py-3 text-right font-mono-plex">{s.total_hours} saat</td>
                <td className="px-4 py-3 text-right whitespace-nowrap">
                  <a
                    href={`${API_BASE}/students/${encodeURIComponent(s.student_id)}/transcript.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`transcript-pdf-${s.student_id}`}
                    className="inline-flex items-center gap-1 px-3 py-1.5 bg-[#0B2046] text-white text-xs hover:bg-[#113066]"
                  >
                    <DownloadSimple size={14} /> Transkript PDF
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
